<div class="content">
  <div class="card bg-light">
    <div class="card-body">
      <p i18n>Release Notes:</p>
      <p>
        {{this.latestRelease?.releaseSettings_Description}}
        <button *ngIf="this.latestRelease?.releaseSettings_FileName != null" mat-button (click)="downloadAttachment()" class="btn btn-bidit-navigate mr-1" i18n>Release Note Details</button>
      </p>
      <div [innerHTML]=this.latestRelease?.releaseSettings_HTML_Bullets></div> 
    </div>
  </div>
</div>
